import { http } from 'utils'

// Authentication state.
const state = {
  client_config: {
    tenant_details: {},
    colours: {},
    modules: {},
    keys: {},
    request_form: {}
  }
}

const getters = {
  client_config: state => state.client_config
}

// Authentication actions.
const actions = {

  getClientConfig ({ commit }) {
    return http.get('client_config')
      .then((response) => {
        commit('SET_CLIENT_CONFIG', response.data)
        return response
      })
  }
}

// Authentication state mutations.
const mutations = {
  SET_CLIENT_CONFIG (state, data) {
    state.client_config = data
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, actions, mutations, getters
}
